import { JwVideoShoppable } from '@/components/JwVideo/Shoppable';
import { LabradorComponent } from '@/types/component';

export const LabradorJwVideoShoppable: LabradorComponent = ({ type, meta, data }) => {
  const { videoData } = data;

  return <JwVideoShoppable mediaId={videoData.videoID} />;
};
